<!-- <ng-container *ngIf="actualDisplay === 'settings'">
  <div class="w-100 d-flex align-items-center justify-content-between">
    <button
      [disabled]="!connected"
      class="btn-large"
      mat-icon-button
      (click)="displayService.stateOn()"
    >
      <mat-icon>arrow_left</mat-icon>
      <span>return to controller</span>
    </button>
    <button class="btn-large" mat-icon-button (click)="close.emit($event)">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <div class="px-1">
    <app-touareg-control-settings
      (close)="close.emit($event)"
    ></app-touareg-control-settings>
  </div>
</ng-container> -->

<ng-container *ngIf="actualDisplay === 'healthMonitoring'">
  <div class="position-relative with-sidebar w-100 h-100 d-flex flex-column">
    <div class="tc-header">
      <div
        class="ctrl-sidebar w-100 h-100 d-flex flex-column align-items-center justify-content-start"
      >
        <button
          class="btn-large"
          mat-icon-button
          (click)="displayService.stateOn()"
        >
          <mat-icon>arrow_back</mat-icon>
        </button>
      </div>
    </div>
    <div class="tc-body">
      <div class="h-100 scroll">
        <app-touareg-control-health></app-touareg-control-health>
      </div>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="actualDisplay === 'state'">
  <app-touareg-control-states
    (close)="close.emit($event)"
  ></app-touareg-control-states>
</ng-container>
